import { PageTemplate } from "@/components/Templates/PageTemplate";
import { useFeatureFlag } from "@/hooks/useFeatureFlag";
import { useScopeParams } from "@/hooks/useScopeParams";
import { FEATURE_FLAGS } from "@/utils/feature-flag-constants";
import type { ExtraTab } from "@/components/Templates/types";
import { SiteMapTab } from "./SiteMapTab";

const extraTabs: ExtraTab[] = [
  {
    type: "custom",
    key: "map",
    title: "Map",
    component: SiteMapTab,
    toolbar: { showOnly: ["workspace", "filters", "guide"] },
    geoEditorHost: true,
  },
];

export default function CrossTrialSiteDirectory() {
  const { buildUrl } = useScopeParams();
  const profileHidden = useFeatureFlag(FEATURE_FLAGS.SITE_PROFILE_LINKS_HIDDEN);
  return (
    <PageTemplate
      title="Portfolio: Sites"
      tooltipText="Cross-trial site profiles showing performance across the portfolio."
      type="portfolio-sites"
      selectionIdentifierColumn="site_key"
      constants={{
        wikiLink: "/wiki/guides/portfolio-sites",
        idLink: profileHidden
          ? undefined
          : (siteKey: string) => buildUrl(`site-profiles/${siteKey}`),
      }}
      extraTabs={extraTabs}
    />
  );
}
